import React, { FC } from 'react'
import { Honeybadger, HoneybadgerErrorBoundary } from '@honeybadger-io/react'

import { HoneybadgerError } from './HoneybadgerError/HoneybadgerError'
import { Environment } from 'Environment'

interface Props {
  children: React.ReactNode
}

export const ErrorMonitoring: FC<Props> = ({ children }) => {
  const honeybadger = Honeybadger.configure({
    apiKey: Environment.HONEYBADGER_API_KEY,
    environment: Environment.HONEYBADGER_ENVIRONMENT,
    revision: Environment.VERSION
  })

  return (
    <HoneybadgerErrorBoundary
      honeybadger={honeybadger}
      ErrorComponent={HoneybadgerError}
    >
      {children}
    </HoneybadgerErrorBoundary>
  )
}
